<template>
  <div class="bg-transparent">
    <div class="history-product-list__wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.history-product-list__wrapper {
  padding: 20px 10px;

  @media (min-width: 1024px) {
    margin: 32px 10px;
    padding: 0 180px;
  }
}
</style>
